import { clearStorage, getFromStorage, setToStorage } from '../utils';
var CACHE_KEY = 'NewPersonalMenu-Current';
var USER_KEY = 'NewPersonalMenu-User';
var SITECOREITEMS_KEY = 'NewPersonalMenu-Items';
var ESHOPITEMS_KEY = 'NewPersonalMenu-EshopItems';
var MERGEDITEMS_KEY = 'NewPersonalMenu-MergedItems';
export function clearAllCache() {
  clearStorage(CACHE_KEY);
  clearStorage(USER_KEY);
  clearStorage(SITECOREITEMS_KEY);
  clearStorage(ESHOPITEMS_KEY);
  clearStorage(MERGEDITEMS_KEY);
}
function ensureCurrentUserCache(customerId, userHash, orderType) {
  var currentCache = getFromStorage(CACHE_KEY);
  if ((currentCache === null || currentCache === void 0 ? void 0 : currentCache.customerId) !== customerId || currentCache.userHash !== userHash || currentCache.orderType !== orderType) {
    clearAllCache();
    setToStorage(CACHE_KEY, {
      customerId: customerId,
      userHash: userHash,
      orderType: orderType
    });
  }
}
export var useLocalCacheStore = function useLocalCacheStore(useCaching, customerId, userHash, orderType) {
  var canUseCache = useCaching && userHash !== null;
  if (canUseCache) {
    ensureCurrentUserCache(customerId, userHash, orderType);
  }
  var getCached = function getCached(key) {
    return canUseCache ? getFromStorage(key) : null;
  };
  var setCached = function setCached(key) {
    return function (value) {
      if (canUseCache) {
        setToStorage(key, value);
      }
    };
  };
  return {
    user: getCached(USER_KEY),
    sitecoreItems: getCached(SITECOREITEMS_KEY),
    eshopItems: getCached(ESHOPITEMS_KEY),
    mergedItems: getCached(MERGEDITEMS_KEY),
    setCachedUser: setCached(USER_KEY),
    setCachedSirecoreItems: setCached(SITECOREITEMS_KEY),
    setCachedEshopItems: setCached(ESHOPITEMS_KEY),
    setCachedMergedItems: function setCachedMergedItems(items) {
      if (canUseCache) {
        clearStorage(SITECOREITEMS_KEY);
        clearStorage(ESHOPITEMS_KEY);
        setCached(MERGEDITEMS_KEY)(items);
      }
    }
  };
};